<template>
  <Alert show-icon type="warning" v-if="errorMsgShow">获取配额数据失败</Alert>
  <i-circle
    v-else
    :size="220"
    :trail-width="4"
    :stroke-width="5"
    :percent="usagePercent"
    stroke-linecap="square"
    stroke-color="#43a3fb">
    <div class="demo-Circle-custom">
      <h1>{{ usagePercent }}%</h1>
      <p>{{ content }}</p>
      <span>配额 <i>{{ circleData.limit }}</i><br/><br/>已用 <i>{{ circleData.in_use }}</i><br/><br/>剩余 <i>{{ remaining }}</i></span>
    </div>
  </i-circle>
</template>
<script>
import { getPrivateCloudCurrentProjectComputeQuota } from '@/api/private-cloud/quota-compute'

export default {
  name: 'quota',
  props: {
    module: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      circleData: {},
      remaining: 0,
      usagePercent: 0,
      errorMsgShow: false
    }
  },
  methods: {
    // 将浮点数四舍五入，取小数点后2位
    toDecimal (x) {
      let f = parseFloat(x)
      if (isNaN(f)) {
        return
      }
      f = Math.round(x * 100)
      return f
    },
    getData () {
      getPrivateCloudCurrentProjectComputeQuota().then(res => {
        this.circleData = res.data.quota_set[this.module]
        this.remaining = this.circleData.limit - this.circleData.in_use
        if (this.circleData.limit) {
          this.usagePercent = this.toDecimal(this.circleData.in_use / this.circleData.limit)
        }
        this.errorMsgShow = false
      }).catch(res => {
        console.log(res.response)
        this.errorMsgShow = true
      })
    }
  }
}
</script>

<style lang="less">
  .demo-Circle-custom{
    & h1{
      color: #3f414d;
      font-size: 28px;
      font-weight: normal;
    }
    & p{
      color: #657180;
      font-size: 14px;
      margin: 10px 0 15px;
    }
    & span{
      display: block;
      padding-top: 15px;
      color: #657180;
      font-size: 14px;
      &:before{
        content: '';
        display: block;
        width: 50px;
        height: 1px;
        margin: 0 auto;
        background: #e0e3e6;
        position: relative;
        top: -15px;
      };
    }
    & span i{
      font-style: normal;
      color: #3f414d;
    }
  }
</style>
